export enum TagModeEnum {
  default = "",
  News = "Tin tức",
  Image = "Image",
  Video = "Video",
}

export enum TagTypeEnum {
  Tag = 0,
  Thread = 1,
  Topic = 2,
}

export function getTagTypeTitle(type: number) {
  switch (type) {
    case TagTypeEnum.Tag:
      return "tag";
    case TagTypeEnum.Thread:
      return "dòng sự kiện";
    default:
      return "chủ đề";
  }
}

export enum ObjectTypeEnum {
    Tag = 1,
    Thread = 2,
}
export function getObjectTypeTitle(type: number) {
  switch (type) {
    case ObjectTypeEnum.Tag:
      return "tag";
    case ObjectTypeEnum.Thread:
      return "dòng sự kiện";
    default:
      return "chủ đề";
  }
}

export enum IdentityErrorsEnum {
  InvalidUserName = "Tên đăng nhập không hợp lệ",
  DuplicateUserName = "Tên đăng nhập đã tồn tại",
  InvalidEmail = "Email không hợp lệ",
  Video = "Video",
}
export const CategoryType = {
    /// <summary>
    /// Hệ đào tạo
    /// </summary>
    training: 1,

    /// <summary>
    /// Ngành học
    /// </summary>
    major: 2,

    documentType: 3,

    reason: 4,

    department: 5,

    facility: 6,

    /// <summary>
    /// Lấy tên loại
    /// </summary>
    /// <param name="type">Loại</param>
    /// <returns>Tên loại</returns>
    getCategoryTypeTitle(type: number) {
        switch (type) {
            case this.training:
                return "Hệ đào tạo";
            case this.major:
                return "Ngành học";
            case this.documentType:
                return "Loại giấy tờ";
            case this.reason:
                return "Lý do";
            case this.department:
                return "Khoa đào tạo";
            case this.facility:
                return "Cơ sở đào tạo";
            default:
                return "";
        }
    },
};


export enum UserTypeEnum {
    All = 0, // Tất cả
    Admin = 1, // Hệ thống
    Student = 2, // Học sinh
}

export const EthnicList: string[] = [
    "Kinh",
    "Tày",
    "Thái",
    "Mường",
    "H'Mông",
    "Khmer",
    "Nùng",
    "Hoa",
    "Dao",
    "Gia Rai",
    "Ê Đê",
    "Ba Na",
    "Sán Chay",
    "Chăm",
    "Cơ Ho",
    "Xơ Đăng",
    "Sán Dìu",
    "Hrê",
    "Ra Glai",
    "Mnông",
    "Thổ",
    "Stiêng",
    "Khơ Mú",
    "Bru - Vân Kiều",
    "Cơ Tu",
    "Giáy",
    "Tà Ôi",
    "Mạ",
    "Co",
    "Hà Nhì",
    "La Chí",
    "Chơ Ro",
    "La Ha",
    "Phù Lá",
    "La Hủ",
    "Lự",
    "Lào",
    "Lô Lô",
    "Chứt",
    "Mảng",
    "Pà Thẻn",
    "Bố Y",
    "Cống",
    "Ngái",
    "Si La",
    "Pu Péo",
    "Rơ Măm",
    "Brâu",
    "Ơ Đu",
    "Rục",
    "Gò Mày",
    "Rơ Ngao",
    "Gié - Triêng",
    "Ma"
];

export enum StudentStatusEnum {
  Unknown = 0,
  Studying = 1, // Đang học
  DroppedOut = 2, // Thôi học
  Graduated = 3, // Đã tốt nghiệp
  Deferred = 4, // Bảo lưu
  Pending = 5, // Chờ
  PendingGraduation = 6, // Chờ tốt nghiệp
  LongTermLeave = 7, // Nghỉ học dài ngày
  DeferredWarning1 = 8, // Bảo lưu cảnh báo 1
  StudyAbroadTransfer = 9, // Chuyển tiếp du học
  TemporarilySuspended = 10, // Đình chỉ tạm thời,
  CompletedVHPT = 12 // Hoàn thành VHPT
}

export const StudentStatusEnumBadge = {
  [StudentStatusEnum.Unknown]: 'secondary',
  [StudentStatusEnum.Studying]: 'success',
  [StudentStatusEnum.DroppedOut]: 'danger',
  [StudentStatusEnum.Graduated]: 'primary',
  [StudentStatusEnum.Deferred]: 'warning',
  [StudentStatusEnum.Pending]: 'info',
  [StudentStatusEnum.PendingGraduation]: 'primary',
  [StudentStatusEnum.LongTermLeave]: 'warning',
  [StudentStatusEnum.DeferredWarning1]: 'danger',
  [StudentStatusEnum.StudyAbroadTransfer]: 'info',
  [StudentStatusEnum.TemporarilySuspended]: 'warning',
  [StudentStatusEnum.CompletedVHPT]: 'primary',
};

export const StudentStatusEnumLabel = {
  [StudentStatusEnum.Unknown]: 'Không xác định',
  [StudentStatusEnum.Studying]: 'Đang học',
  [StudentStatusEnum.DroppedOut]: 'Thôi học',
  [StudentStatusEnum.Graduated]: 'Đã tốt nghiệp',
  [StudentStatusEnum.Deferred]: 'Bảo lưu',
  [StudentStatusEnum.Pending]: 'Chờ',
  [StudentStatusEnum.PendingGraduation]: 'Chờ tốt nghiệp',
  [StudentStatusEnum.LongTermLeave]: 'Nghỉ học dài ngày',
  [StudentStatusEnum.DeferredWarning1]: 'Bảo lưu cảnh báo 1',
  [StudentStatusEnum.StudyAbroadTransfer]: 'Chuyển tiếp du học',
  [StudentStatusEnum.TemporarilySuspended]: 'Đình chỉ tạm thời',
  [StudentStatusEnum.CompletedVHPT]: 'Hoàn thành VHPT',
};

export enum StudentProcessStatusEnum {
    /// <summary>
    /// Tuyển sinh nhập thông tin
    /// </summary>
    Input = 1,

    /// <summary>
    /// Tuyển sinh gửi cho kế toán
    /// </summary>
    SendAccounting = 2,

    /// <summary>
    /// Kế toán duyệt
    /// </summary>
    SendAdmissions = 3,

     /// <summary>
    /// Phụ huynh xác nhận hoàn thiện
    /// </summary>
    ParentCompletedInput = 4,

    /// <summary>
    /// Tuyển sinh xác nhận hoàn thiện
    /// </summary>
    AdmissionConfirm= 5,

    /// <summary>
    /// Tuyển sinh bổ sung
    /// </summary>
    AdmissionSupplemented = 6,

    /// <summary>
    /// Công tác sinh viên trả lại yêu cầu bổ sung
    /// </summary>
    Refuse = 7,

    /// <summary>
    /// Duyệt hồ sơ tuyển sinh
    /// </summary>
    Approved = 8,
}

export enum StudentStepEnum  {
    /// <summary>
    /// Nhập liệu
    /// </summary>
    Input = 1,

    /// <summary>
    /// Thu phí
    /// </summary>
    Fee = 2,

    /// <summary>
    /// Kiểm tra hồ sơ
    /// </summary>
    Data = 3,

    /// <summary>
    /// Báo nhập học
    /// </summary>
    Notice = 4,

    /// <summary>
    /// Nhập học
    /// </summary>
    Admission = 5,

    /// <summary>
    /// Phân lớp
    /// </summary>
    Classify = 6
}

export const StudentProcessObjectEnum = {
    0: {
        title: "",
        badge: "secondary",
        icon: "",
    },
    1: {
        title: "Lưu tạm",
        badge: "secondary",
        icon: "fa-solid fa-file-pen",
    },
    2: {
        title: "Chờ KT duyệt",
        badge: "info",
        icon: "fa-solid fa-file-invoice-dollar",
    },
    3: {
        title: "Gửi TS",
        badge: "primary1",
        icon: "fa-solid fa-file-check",
    },
    4: {
        title: "PH hoàn thiện",
        badge: "dark",
        icon: "fa-solid fa-file-check",
    },
  
    5: {
        title: "TS xác nhận",
        badge: "primary",
        icon: "fa-solid fa-file-pen",
    },
    6: {
        title: "Đã bổ sung",
        badge: "warning",
        icon: "fa-solid fa-file-xmark",
    },
    7: {
        title: "Từ chối",
        badge: "danger",
        icon: "fa-solid fa-file-circle-check",
    },
    8: {
        title: "Đã duyệt",
        badge: "success",
        icon: "fa-solid fa-file-circle-check",
    },
};

export const StudentStepObjectEnum = {
    0: {
        title: "",
        badge: "secondary",
        icon: "",
    },
    1: {
        title: "Nhập liệu",
        badge: "primary",
        icon: "fa-solid fa-file-pen",
    },
    2: {
        title: "Thu phí",
        badge: "primary",
        icon: "fa-solid fa-file-invoice-dollar",
    },
    3: {
        title: "Kiểm tra hồ sơ",
        badge: "primary",
        icon: "fa-solid fa-file-lines",
    },
    4: {
        title: "Báo nhập học",
        badge: "primary",
        icon: "fa-solid fa-file-circle-check",
    },
    5: {
        title: "Nhập học",
        badge: "primary",
        icon: "fa-solid fa-file-circle-check",
    },
    6: {
        title: "Phân lớp",
        badge: "primary",
        icon: "fa-solid fa-file-circle-check",
    }
}
export enum ReceiptTypeEnum {
    //[BDescriptionAttribute("Học phí")]
        TuitionFee = 1,
    //[BDescriptionAttribute("Đặt cọc/ghi danh")]
        Deposit = 2,
    //[BDescriptionAttribute("Khác")]
        Other = 3
}

export enum ReceiptStatusEnum {
    Unpaid = 1,
    Paid = 2,
    Pending = 3
}

export enum PaymentMethodEnum {
    Cash = 1,
    BankTransfer = 2,
    OnlinePayment = 3
}

export enum ReceiptDetailTypeEnum {
    Income = 1,
    Scholarship = 2,
    Deduction = 3
}
